export default "__VITE_ASSET__C_x7Ytpe__"